import React, { Suspense, useContext, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Svg } from './Svg';
import { centerGates, centersI } from '../../static/centers_dictionary';
import { numbers_dictionary } from '../../static/numbers_dictionary';
import { numbers_selects } from '../../static/numbers_selects';
import { channels_dictionary } from '../../static/channels_dictionary';
import { gates_paths, gates_paths_thin } from '../../static/gates_svg';

import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { default_design } from '../../static/default_design';
import { gates_dictionary } from '../../static/gates_dictionary';
import {
  defineAuthority,
  getAvatarThumbnailUrl,
  getDesignCenters,
  handleCenterClick,
  handleChannelClick
} from '../utilsDesign';
import { BodyArrows } from './BodyArrows';
import bodygraphsvg from './bodygraph.svg';
import { BodyHint } from './BodyHint';
import { chakras, colors, theme } from './Colors';
import { Preloader, Preloader0 } from './kit';
import { Planets } from './Planets';
import { PopoverH, TooltipH } from './TooltipH';
import { getPentaDesign } from '../utilsPenta';
import { useIsMobile } from '../useIsMobile';
import './Bodygraph3D/Bodygraph3D.css';

const Bodygraph3D = React.lazy(() =>
  import('./Bodygraph3D/Bodygraph3D').then((mod) => ({ default: mod.Bodygraph3D }))
);

const OVERLAPPING_CHANNEL_IDS = ['20-57', '10-57', '34-57', '10-34', '20-34', '10-20'];
const CHANNEL_PICKER_TRIGGER_ID = '10-57';

const ChannelPickerMenu = ({ onHover, onSelect }) => {
  const context = useContext(LangContext);
  const $ui = context.$ui;
  const $channel = context.$channel;

  return (
    <div className="x_body_channel_picker">
      {OVERLAPPING_CHANNEL_IDS.map(id => (
        <div
          key={id}
          className="x_body_channel_picker_item"
          onMouseEnter={() => onHover(id)}
          onMouseOver={() => onHover(id)}
          onClick={(e) => {
            e.stopPropagation();
            onSelect(id);
          }}
        >
          {id} <span className="x_edu_channel_of">{$ui('channel_of')}</span> <b>{$channel(id, 'title')}</b>
        </div>
      ))}
    </div>
  );
};








export const Bodygraph = React.memo(({
  markers,
  penta,
  hints,
  interactive,
  hoverable,
  body = true,
  children,
  designComposite = {},
  centers = ['HD', 'AA', 'TT', 'HT', 'GC', 'SN', 'SL', 'SP', 'RT'],
  activePage,
  design = default_design,
  width,
  height,
  lines = true,
  authority,
  numbers,
  dim = true,
  planets,
  planetsPrs,
  planetsDes,
  // size,
  bodyContainer,
  blur,
  arrowsP,
  arrowsB,
  preloader,
  composite,
  whiteLines = true,
  // Leaves undefined centers and open gates unpainted instead of white, so
  // whatever is drawn behind the bodygraph shows through.
  openTransparent = false,
  omitGates = [],
  omitCenters = [],
  questionPlanets,
  style,
  advanced,
  parentContainer,

  focusedCenter,
  highlighted = [],
  highlightedGate = [],

  colorTheme = {},
  addClassName = '',
  aura = false,

  default_colors = 'base',
  png = false,
  avatarToken,
  avatarUpdated,

  // Swaps the flat SVG for the WebGL bodygraph in the same slot, so it inherits
  // the size of whatever container the 2D version was already sized by.
  // `3d` is not a legal JSX attribute name, so it arrives via a spread such as
  // Preview's `bodyAdd`; `mode3d` is the equivalent for direct JSX use.
  '3d': threeD,
  mode3d,
  orbit3d = false,
  autoRotate3d = false,
  appear3d = false,
}) => {

  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $center = context.$center;
  const $channel = context.$channel;
  const $ui = context.$ui;

  const [colorThemeInner, setColorThemeInner] = useState({
    ...theme,
    ...colorTheme
  })

  useEffect(() => {
    setColorThemeInner({
      ...theme,
      ...colorTheme
    })
  }, [colorTheme])



  // design = (design && design[0] && design[0].type) ? design[0] : default_design
  design = design ? design : default_design;

  const use3d = Boolean(threeD || mode3d);

  const sizes = {
    sm: {
      width: 36,
      height: 64,
    },
    md: {
      width: 90,
      height: 120,
    },
    preview: {
      width: 300,
      height: 380,
    },
    full: {
      width: 600,
      height: 780,
    },
  };


  const [svgWidth, setSvgWidth] = useState(width);
  const [svgHeight, setSvgHeight] = useState(height);
  const [thumbnailFailed, setThumbnailFailed] = useState(false);
  const [thumbnailType, setThumbnailType] = useState('transparent');

  const wantPngMode = png
    && !use3d
    && avatarToken
    && design
    && design.id !== 'dummy';
  const thumbnailUrl = wantPngMode && !thumbnailFailed
    ? getAvatarThumbnailUrl(avatarToken, thumbnailType, avatarUpdated)
    : null;
  const usePngMode = Boolean(thumbnailUrl);


  const [highlightedInner, setHighlightedInner] = useState(highlighted);
  const [highlightedGateInner, setHighlightedGateInner] = useState(highlightedGate);
  const [channelPickerId, setChannelPickerId] = useState(null);
  const isMobile = useIsMobile(480);

  function arraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    const sortedArr1 = arr1.slice().sort();
    const sortedArr2 = arr2.slice().sort();
    return sortedArr1.every((value, index) => value === sortedArr2[index]);
  }

  useEffect(() => {
    if (!arraysEqual(highlighted, highlightedInner)) {
      setHighlightedInner(highlighted)
    }
  }, [highlighted])
  useEffect(() => {
    if (!arraysEqual(highlightedGate, highlightedGateInner)) {
      setHighlightedGateInner(highlightedGate)
    }
  }, [highlightedGate])


  const setWH = () => {
    if (usePngMode) {
      setSvgWidth(166);
      return;
    }

    if (parentContainer && parentContainer.current) {
      let clientWidth, clientHeight;
      clientWidth = parentContainer.current.clientWidth;
      clientHeight = parentContainer.current.clientHeight;
      setSvgWidth(clientWidth)
      setSvgHeight(clientHeight)
    }

    // if (width && height) {
    //   clientWidth = width;
    //   clientHeight = height;
    // } else if (parentContainer && parentContainer.current) {
    //   clientWidth = parentContainer.current.clientWidth;
    //   clientHeight = parentContainer.current.clientHeight;
    // } else {
    //   clientWidth = sizes['md'].width;
    //   clientHeight = sizes['md'].height;
    // }

    // if (clientWidth && clientWidth !== svgWidth) {
    //   console.log('clientWidth = ', clientWidth);
    //   console.log('clientHeight = ', clientHeight);
    //   setSvgWidth(clientWidth ? clientWidth : svgWidth)
    //   setSvgHeight(clientHeight ? clientHeight : svgHeight)
    //   // setSvgWidth(svgWidth)
    //   // setSvgHeight(svgHeight)
    // }
  }


  const location = useLocation();
  const navigate = useNavigate();

  const handleCenterClickInner = (centerId) => {
    context.setState.setHighlighted([centerId]);
    context.setState.setSearch([]);
    handleCenterClick(centerId, location, navigate);
  };
  const handleChannelClickInner = (channelId) => {
    const centers = channels_dictionary.filter(one => one.id === channelId)[0].centers;
    const gates = channels_dictionary.filter(one => one.id === channelId)[0].gates;
    context.setState.setHighlighted([...centers]);
    context.setState.setSearch([...gates]);
    handleChannelClick(channelId, location, navigate);
  };

  
  const handleChannelHover = (channelId) => {
    // console.log('channelId = ', channelId);


    if (channelId) {
      const centers = channels_dictionary.filter(one => one.id === channelId)[0].centers;
      const gates = channels_dictionary.filter(one => one.id === channelId)[0].gates;
      // context.setState.setHighlighted([...centers]);
      // context.setState.setSearch([...gates]);
      setHighlightedInner([...centers]);
      setHighlightedGateInner([...gates]);
      // handleChannelClick(channelId, location, navigate);
    } else {
      // context.setState.setHighlighted([...highlighted]);
      // context.setState.setSearch([...highlightedGate]);
      setHighlightedInner([...highlighted]);
      setHighlightedGateInner([...highlightedGate]);
    }
  };

  const handleCenterHover = (center) => {
    // context.setState.setHighlighted(center)
  }



  // const [svgWidth, setSvgWidth] = useState(width ? sizes['md'].width : width);
  // const [svgHeight, setSvgHeight] = useState(height ? sizes['md'].height : height);





  const chakra = (ch, definedCenters) => {
    // return design['active_chakras'] ? design['active_chakras'].indexOf(ch) > -1 : false
    return definedCenters ? definedCenters.indexOf(ch) > -1 : false
  }

  const composite1 = penta && penta.members[0] ? penta.members[0].avatar.token : null;
  const composite2 = penta && penta.members[1] ? penta.members[1].avatar.token : null;

  const pentaColors = {

  }
  pentaColors[composite1] = 'composite1';
  pentaColors[composite2] = 'composite2';

  const bodyType = !composite ? default_colors : composite === 1 ? 'composite1' : 'composite2';

  // const pentaDesign = penta 
  //   ? penta.pentaDesign || getPentaDesign(penta) 
  //   : {};
  const pentaDesign = penta ? penta.pentaDesign : default_design;




  const centerColor = (centerName, definedCenters, highlighted = []) => {
    definedCenters = definedCenters || getDesignCenters(design['gates'], designComposite['gates']);
    // let clr = chakra(centerName, definedCenters) ? dim || highlighted ? colors.highlightDimmed : definedChakra : openChakra;
    // let clr = chakra(centerName) ? dim || highlighted ? colorThemeInner.highlightDimmed : centersI[centerName]['color'][theme] : colorThemeInner.openColor;

    // let clr = definedCenters.includes(centerName) ?
    //   (centerName === context.state.highlighted && hoverable) ?
    //     colorThemeInner.highlightColor : definedChakra
    //   : (centerName === context.state.highlighted && hoverable) ?
    //     colorThemeInner.highlightColorInactive : openChakra;

    const isBleak = (centerName) => highlighted.length > 0 && !highlighted.includes(centerName);

    const getDefinedColor = (centerName) => {
      return isBleak(centerName)
        ? colors[context.state.colorMode][`chakra${centerName}definedBleak`]
        : colors[context.state.colorMode][`chakra${centerName}defined`];
    }

    const getOpenColor = (centerName) => {
      if (openTransparent) return 'rgba(255, 255, 255, 0.5)';
      return isBleak(centerName)
        ? colors[context.state.colorMode][`chakra${centerName}openBleak`]
        : colors[context.state.colorMode][`chakra${centerName}open`];
    }

    let clr = definedCenters.includes(centerName) && !omitCenterSet.has(centerName)
      ? getDefinedColor(centerName)
      : getOpenColor(centerName);
    // let clr = chakra(centerName, definedCenters) ? definedChakra : openChakra;
    // clr = highlighted === centerName && width < 100 ? colors.highlightColor : clr;
    if (authority && defineAuthority(definedCenters) === centerName) {
      clr = colors.authorityColor
    };
    return clr;
  }




  const personGatesObj = useMemo(() => {
    const obj = {};
    if (!design || !design['gates']) return obj;
    design['gates'].forEach((one) => {
      if (!one) return;
      const key = one['gate'].toString();
      if (!obj[key]) {
        obj[key] = [{ ...one }];
      } else {
        obj[key].push({ ...one });
      }
    });
    return obj;
  }, [design]);

  const omitGateSet = useMemo(
    () => new Set((omitGates || []).map((gate) => Number(gate))),
    [omitGates]
  );

  const omitCenterSet = useMemo(
    () => new Set(omitCenters || []),
    [omitCenters]
  );

  const personGatesKeys = useMemo(
    () => Object.keys(personGatesObj).filter((gate) => !omitGateSet.has(Number(gate))),
    [personGatesObj, omitGateSet]
  );

  const personGatesFocused = useMemo(() => {
    if (!focusedCenter) return personGatesKeys;
    const ifGateIsActivated = (gate) =>
      personGatesKeys.includes(gate.toString());
    const ret = [];
    personGatesKeys.forEach(gateNumber => {
      gateNumber = parseInt(gateNumber);
      let r = false;
      channels_dictionary.forEach(oneChannel => {
        const index = oneChannel['gates'].findIndex((gate) => gate === gateNumber);
        let connected = false;
        connected = oneChannel['centers'][index] === focusedCenter ? true : connected;
        if (index > -1) {
          const otherGate = index === 0 ? oneChannel['gates'][1] : oneChannel['gates'][0];
          const otherGateActivated = ifGateIsActivated(otherGate);
          connected = otherGateActivated && oneChannel['centers'].includes(focusedCenter) ? true : connected;
        }
        r = connected ? true : r;
      });
      if (r) ret.push(gateNumber);
    });
    return ret;
  }, [personGatesKeys, focusedCenter]);


  const gateColor = (gateId, secondary) => {
    // return 'black'

    let bodyType = default_colors;
    
    
    if (penta) {
      const gateInfo = pentaDesign.gates.filter((oneGate) => oneGate && oneGate.gate == gateId)[0];
      // bodyType = !gateInfo ? default_colors : default_colors;
      if (penta.members.length === 2) {
        bodyType = !gateInfo || Object.keys(gateInfo.activatedBy).length > 1
          ? 'composite1'
          : pentaColors[Object.keys(gateInfo.activatedBy)[0]];
      }
      if (!bodyType) {
        bodyType = 'base'
      }
    }
    const color = colors[context.state.colorMode][bodyType];

    let returnColor = color['open'];
    if (personGatesObj[gateId]) {
      let clrs = []
      personGatesObj[gateId].map((oneActivation) => {
        clrs.push(oneActivation['label'])
      })
      clrs = [...new Set(clrs)];
      if ([...new Set(clrs)].length > 1) {
        return !secondary ? color[clrs[0]] : color[clrs[1]]
      } else {
        return color[clrs[0]];
      }

    } else {
      return returnColor;
    }
  }


  const drawGates = (highlighted, highlightedGateInner = []) => {

    const gates64 = [];
    for (let i = 1; i <= 64; i++) { gates64.push(i.toString()); }

    let emptyGates = focusedCenter ? [] : gates64.filter(value => !personGatesKeys.includes(value));


    let gates_svg = '';



    const selectWidth = 6;


    // gates_svg = gates_svg.replaceAll('gateWidth', 8);

    let gates_select = '';
    emptyGates
      .filter(oneGateNum => highlightedGateInner.includes(parseInt(oneGateNum)))
      .forEach(oneGateNum => {
        oneGateNum = typeof oneGateNum === 'string' ? parseInt(oneGateNum) : oneGateNum;
        let gatePathSelect = gates_paths[oneGateNum];
        gatePathSelect = gatePathSelect.replace('strokeWidth', selectWidth);
        const highlightColor = colorThemeInner.highlightedGateInnerColor;
        gatePathSelect = gatePathSelect.replace('strokeColor', highlightColor);
        gatePathSelect = gatePathSelect.replace('gateColor', highlightColor)
        gates_select = gates_select + gatePathSelect + '\n';
      })


    emptyGates
      .forEach(oneGateNum => {
        oneGateNum = typeof oneGateNum === 'string' ? parseInt(oneGateNum) : oneGateNum;
        let gatePath = gates_paths[oneGateNum];
        gates_svg += gatePath + '\n'
        // gates_svg += gates_paths_thin[oneGateNum] + '\n'
      })
    const openGateColor = openTransparent
      ? 'rgba(255, 255, 255, 0.5)'
      : highlightedGate.length ? colorThemeInner.openColor2 : colors[context.state.colorMode][bodyType]['open'];
    gates_svg = gates_svg.replaceAll('gateColor', openGateColor);

    gates_svg = gates_svg + gates_select;

    personGatesFocused
      .filter(oneGateNum => !highlightedGateInner.includes(parseInt(oneGateNum)))
      .forEach(oneGateNum => {
        let gatePath = gates_paths[oneGateNum];
        let gateCol = gateColor(oneGateNum);
        let gateCbleak = gateCol === colorThemeInner.designColor ? colorThemeInner.designColor2 : colorThemeInner.personalityColor2;

        // console.log('highlightedGateInner = ', highlightedGateInner);



        if (highlightedGateInner.length && !highlightedGateInner.includes(oneGateNum)) gateCol = gateCbleak;
        if (dim && highlightedInner.length) {
          const gateInHighlightedCenter = []
          gateInHighlightedCenter.push(
            ...highlightedInner.map(oneCenter => centerGates[oneCenter])
          )
          gateCol = (gateInHighlightedCenter.flat().includes(oneGateNum)) ? gateCol : gateCbleak;
        }

        gatePath = gatePath.replace('gateColor', gateCol)
        // gatePath = gatePath.replace('gateColor', gateC);
        gatePath = gatePath.replaceAll('gateWidth', 8);

        gates_svg += gatePath + '\n';

        if (personGatesObj[oneGateNum].length > 1) {
          let gatePathThin = gates_paths_thin[oneGateNum]
          let gateColor2 = gateColor(oneGateNum, true);
          // console.log('gatePathThin = ', gatePathThin);
          // gatePathThin = gatePathThin.replace('gateColor', gateCthin);
          gatePathThin = gatePathThin.replace('gateColor', gateColor2);
          gates_svg += gatePathThin + '\n';
        }
      })


    // SELECTED


    // emptyGates
    //   .filter(oneGateNum => highlightedGateInner.includes(parseInt(oneGateNum)))
    //   .forEach(oneGateNum => {
    //     oneGateNum = typeof oneGateNum === 'string' ? parseInt(oneGateNum) : oneGateNum;
    //     let gatePath = gates_paths[oneGateNum];
    //     let gateOpenColor = colors[bodyType]['open'];
    //     gatePath = gatePath.replace('gateColor', gateOpenColor)
    //     gates_select = gates_select + gatePath + '\n';
    //   })


    personGatesFocused
      .filter(oneGateNum => highlightedGateInner.includes(parseInt(oneGateNum)))
      .forEach(oneGateNum => {
        let gatePathSelect = gates_paths[oneGateNum];
        // const highlightColor = colorThemeInner.highlightedGateInnerColor;
        const highlightColor = gateColor(oneGateNum);
        gatePathSelect = gatePathSelect.replace('strokeWidth', selectWidth);
        gatePathSelect = gatePathSelect.replace('strokeColor', highlightColor);
        gatePathSelect = gatePathSelect.replace('gateColor', highlightColor)
        gates_select = gates_select + gatePathSelect + '\n';
      })



    // SELECT TOP
    emptyGates
      .filter(oneGateNum => highlightedGateInner.includes(parseInt(oneGateNum)))
      .forEach(oneGateNum => {
        oneGateNum = typeof oneGateNum === 'string' ? parseInt(oneGateNum) : oneGateNum;
        let gatePathSelect = gates_paths[oneGateNum];
        const highlightColor = colorThemeInner.highlightedGateInnerColor;
        gatePathSelect = gatePathSelect.replace('strokeWidth', selectWidth);
        gatePathSelect = gatePathSelect.replace('strokeColor', highlightColor);
        gatePathSelect = gatePathSelect.replace('gateColor', highlightColor)
        gates_select = gates_select + gatePathSelect + '\n';
      })
    emptyGates
      .filter(oneGateNum => highlightedGateInner.includes(parseInt(oneGateNum)))
      .forEach(oneGateNum => {
        oneGateNum = typeof oneGateNum === 'string' ? parseInt(oneGateNum) : oneGateNum;
        let gatePath = gates_paths[oneGateNum];
        let gateOpenColor = colors[context.state.colorMode][bodyType]['open'];
        gatePath = gatePath.replace('gateColor', gateOpenColor)
        gates_select = gates_select + gatePath + '\n'
        // gates_svg += gates_paths_thin[oneGateNum] + '\n'
      })

    personGatesFocused
      .filter(oneGateNum => highlightedGateInner.includes(parseInt(oneGateNum)))
      .forEach(oneGateNum => {
        let gatePath = gates_paths[oneGateNum];
        let gateC = gateColor(oneGateNum);
        gatePath = gatePath.replace('gateColor', gateC)
        gates_select = gates_select + gatePath + '\n';
        if (personGatesObj[oneGateNum].length > 1) {
          let gatePathThin = gates_paths_thin[oneGateNum]
          let gateColor2 = gateColor(oneGateNum, true);

          //TODO: fix thin channels
          // gateColor2 = gateColor(oneGateNum, true) === colorThemeInner.designColor 
          //   ? colorThemeInner.designColor2 
          //   : highlightedGate.includes(oneGateNum) ? colorThemeInner.designColor2 : colorThemeInner.personalityColor2;
          
          // console.log('gatePathThin = ', gatePathThin);
          // gatePathThin = gatePathThin.replace('gateColor', gateCthin);
          gatePathThin = gatePathThin.replace('gateColor', gateColor2);
          gates_select += gatePathThin + '\n';
        }
      })


    gates_svg = gates_svg + gates_select;
    return gates_svg;
  }
  const drawGatesHighlighted = (highlighted, highlightedGateInner = []) => {

    const gates64 = [];
    for (let i = 1; i <= 64; i++) { gates64.push(i.toString()); }

    let emptyGates = focusedCenter ? [] : gates64.filter(value => !personGatesKeys.includes(value));


    let gates_svg = '';



    const selectWidth = 6;


    // gates_svg = gates_svg.replaceAll('gateWidth', 8);

    let gates_select = '';
    // emptyGates
    //   .filter(oneGateNum => highlightedGateInner.includes(parseInt(oneGateNum)))
    //   .forEach(oneGateNum => {
    //     oneGateNum = typeof oneGateNum === 'string' ? parseInt(oneGateNum) : oneGateNum;
    //     let gatePathSelect = gates_paths[oneGateNum];
    //     gatePathSelect = gatePathSelect.replace('strokeWidth', selectWidth);
    //     const highlightColor = colorThemeInner.highlightedGateInnerColor;
    //     gatePathSelect = gatePathSelect.replace('strokeColor', highlightColor);
    //     gatePathSelect = gatePathSelect.replace('gateColor', highlightColor)
    //     gates_select = gates_select + gatePathSelect + '\n';
    //   })



    // SELECTED


    // emptyGates
    //   .filter(oneGateNum => highlightedGateInner.includes(parseInt(oneGateNum)))
    //   .forEach(oneGateNum => {
    //     oneGateNum = typeof oneGateNum === 'string' ? parseInt(oneGateNum) : oneGateNum;
    //     let gatePath = gates_paths[oneGateNum];
    //     let gateOpenColor = colors[context.state.colorMode][bodyType]['open'];
    //     gatePath = gatePath.replace('gateColor', gateOpenColor)
    //     gates_select = gates_select + gatePath + '\n';
    //   })


    personGatesFocused
      .filter(oneGateNum => highlightedGateInner.includes(parseInt(oneGateNum)))
      .forEach(oneGateNum => {
        let gatePathSelect = gates_paths[oneGateNum];
        // const highlightColor = colorThemeInner.highlightedGateInnerColor;
        const highlightColor = gateColor(oneGateNum);
        gatePathSelect = gatePathSelect.replace('strokeWidth', selectWidth);
        gatePathSelect = gatePathSelect.replace('strokeColor', highlightColor);
        gatePathSelect = gatePathSelect.replace('gateColor', highlightColor)
        gates_select = gates_select + gatePathSelect + '\n';
      })



    // SELECT TOP
    emptyGates
      .filter(oneGateNum => highlightedGateInner.includes(parseInt(oneGateNum)))
      .forEach(oneGateNum => {
        oneGateNum = typeof oneGateNum === 'string' ? parseInt(oneGateNum) : oneGateNum;
        let gatePathSelect = gates_paths[oneGateNum];
        const highlightColor = colorThemeInner.highlightedGateInnerColor;
        gatePathSelect = gatePathSelect.replace('strokeWidth', selectWidth);
        gatePathSelect = gatePathSelect.replace('strokeColor', highlightColor);
        gatePathSelect = gatePathSelect.replace('gateColor', highlightColor)
        gates_select = gates_select + gatePathSelect + '\n';
      })
    emptyGates
      .filter(oneGateNum => highlightedGateInner.includes(parseInt(oneGateNum)))
      .forEach(oneGateNum => {
        oneGateNum = typeof oneGateNum === 'string' ? parseInt(oneGateNum) : oneGateNum;
        let gatePath = gates_paths[oneGateNum];
        let gateOpenColor = colors[context.state.colorMode][bodyType]['open'];
        gatePath = gatePath.replace('gateColor', gateOpenColor)
        gates_select = gates_select + gatePath + '\n'
        // gates_svg += gates_paths_thin[oneGateNum] + '\n'
      })

    personGatesFocused
      .filter(oneGateNum => highlightedGateInner.includes(parseInt(oneGateNum)))
      .forEach(oneGateNum => {
        let gatePath = gates_paths[oneGateNum];
        let gateC = gateColor(oneGateNum);
        gatePath = gatePath.replace('gateColor', gateC)
        gates_select = gates_select + gatePath + '\n';
        if (personGatesObj[oneGateNum].length > 1) {
          let gatePathThin = gates_paths_thin[oneGateNum]
          let gateColor2 = gateColor(oneGateNum, true);
          // console.log('gatePathThin = ', gatePathThin);
          // gatePathThin = gatePathThin.replace('gateColor', gateCthin);
          gatePathThin = gatePathThin.replace('gateColor', gateColor2);
          gates_select += gatePathThin + '\n';
        }
      })








    gates_svg = gates_svg + gates_select;
    return gates_svg;
  }


  const strokeColor = (centerName) => {
    const stroke = '#00000018'
    let clr = chakra(centerName) ?
      dim ?
        colorThemeInner.highlightDimmed
        : stroke
      : stroke;
    // let clr = 'transparent';
    // let clr = 'blue';
    return highlightedInner.includes(centerName) ? colorThemeInner.highlightColor : clr;
  }

  const strokeWidth = (centerName) => {
    const stroke = 1
    let clr = chakra(centerName) ?
      dim ?
        5
        : stroke
      : stroke;
    // let clr = 'transparent';
    // let clr = 'blue';
    return highlightedInner.includes(centerName) ? 5 : clr;
  }


  const body_contour = `<path d="M184.403 288.337C160.903 294 152.885 305.5 135.903 332.5C118.92 359.5 69.8444 450.734 46.4025 537C33.9025 583 28.6168 624.5 52.9025 658.5C105.281 731.83 184.173 776.547 276.083 776.547C324.051 776.547 295.886 777.567 330.587 776.547C419.772 773.924 504.347 725.762 550.903 648.5C567.523 620.918 565.153 578 555.902 541C532.277 446.5 470.403 340.5 452.426 318.785C441.856 306.016 431.903 293.5 413.903 288.337C389.595 281.365 355.978 276.603 351.386 238.341C347.369 204.875 361.592 198.038 374.349 168.958C387.107 139.879 388.791 110.799 371.798 83.2501C354.805 55.7011 322.298 47.5384 295.252 47.0283C268.206 46.5181 253.073 52.855 236.567 71.0061C221.258 87.8417 216.665 119.472 218.196 124.064C219.727 128.655 222.789 130.186 224.32 136.308C225.596 141.409 214.624 158.755 212.073 164.877C209.521 170.999 212.583 173.04 218.196 176.101C221.882 178.11 222.789 182.223 222.789 190.895C222.789 199.568 221.769 199.058 222.789 211.302C223.81 223.546 232.717 225.579 243.712 222.526C252.897 219.975 255.959 224.566 255.959 233.239C255.959 241.912 252.897 254.156 232.995 270.992C218.629 283.144 204.888 283.401 184.403 288.337Z"
  stroke="black" stroke-opacity="0.1"
  />`

  const markerHighlightedGates = markers === 'sameGates'
    ? (pentaDesign?.sameGates || []).map((one) => Number(one.gate))
    : highlightedGateInner;

  // fill='white'
  // style="mix-blend-mode:multiply"



  const lines_svg = `<svg width="600" height="800" viewBox="0 0 600 800" fill="none" xmlns="http://www.w3.org/2000/svg">
    ${drawGates(highlighted, markerHighlightedGates)}
  </svg>
  `
  const lines_svg_selected = `<svg width="600" height="800" viewBox="0 0 600 800" fill="none" xmlns="http://www.w3.org/2000/svg">
    ${drawGatesHighlighted([], markerHighlightedGates)}
  </svg>
  `


  const renderCenter = (center, centerColor, strokeColor, strokeWidth) => {
    if (center === 'HD') {
      return `<g>
        <path
        id="${center}"
        d="M287.467 34.435C294.887 27.0151 304.918 27.0151 312.338 34.435L351.936 97.033C357.371 107 351.936 117.903 339.935 117.903C326.371 117.903 272.871 117.903 258.869 117.903C244.868 117.903 242.871 104.5 247.869 97.033L287.467 34.435Z"
        fill="${centerColor}"
        stroke="${strokeColor}"
        stroke-width="${strokeWidth}"
        />
      </g>`
    }
    if (center === 'AA') {
      return `<g>
      <path
      id="AA"
      d="M311.338 221.483C303.918 228.903 293.887 228.903 286.467 221.483L246.869 158.885C241.434 148.918 246.869 138.015 258.87 138.015C272.434 138.015 325.934 138.015 339.935 138.015C353.937 138.015 355.934 151.418 350.936 158.885L311.338 221.483Z"
        fill="${centerColor}"
        stroke="${strokeColor}"
        stroke-width="${strokeWidth}"
      />
    </g>`
    }
    if (center === 'TT') {
      return `<g>
      <rect

      x="251.902" y="257" width="94" height="94" rx="19"
        fill="${centerColor}"
        stroke="${strokeColor}"
      stroke-width="${strokeWidth}"
      />
    </g>`
    }
    if (center === 'GC') {
      return `<g>
      <rect x="232.902" y="432" width="94" height="94" rx="19" transform="rotate(-45 232.902 432)"
        fill="${centerColor}"
        stroke="${strokeColor}"
      stroke-width="${strokeWidth}"
      />
    </g>`
    }
    if (center === 'HT') {
      return `<g>
      <path d="M402.68 458.579C409.415 453.651 416.376 454.979 421.42 461.872L446.721 513.981C449.9 522.641 444.344 530.606 434.82 529.017C424.053 527.221 381.588 520.137 370.475 518.283C359.362 516.429 359.302 505.488 364.121 500.202L402.68 458.579Z"
        fill="${centerColor}"
        stroke="${strokeColor}"
      stroke-width="${strokeWidth}"
      />
    </g>`
    }
    if (center === 'SP') {
      return `<g>
      <path d="M434.338 603.903C426.918 596.483 426.918 586.453 434.338 579.033L496.936 539.435C506.902 534 517.806 539.435 517.806 551.435C517.806 565 517.806 618.5 517.806 632.501C517.806 646.502 504.402 648.5 496.936 643.501L434.338 603.903Z"
        fill="${centerColor}"
        stroke="${strokeColor}"
      stroke-width="${strokeWidth}"
      />
      </g>`
    }
    if (center === 'SN') {
      return `<g>
      <path d="M163.483 603.903C170.903 596.483 170.903 586.453 163.483 579.033L100.885 539.435C90.9182 534 80.0152 539.435 80.0152 551.435C80.0152 565 80.0152 618.5 80.0152 632.501C80.0152 646.502 93.4182 648.5 100.885 643.501L163.483 603.903Z"
        fill="${centerColor}"
        stroke="${strokeColor}"
      stroke-width="${strokeWidth}"
      />
</g>`
    }
    if (center === 'SL') {
      return `<g>
      <rect x="251.902" y="553" width="94" height="94" rx="19"
        fill="${centerColor}"
        stroke="${strokeColor}"
      stroke-width="${strokeWidth}"
      />
</g>`
    }
    if (center === 'RT') {
      return `<g>
      <rect x="251.902" y="675" width="94" height="94" rx="19"
        fill="${centerColor}"
        stroke="${strokeColor}"
      stroke-width="${strokeWidth}"
      />
</g>`
    }
  }

  const Center = ({ center, className, centerColor }) => {
    const c = `<svg
    xmlns="http://www.w3.org/2000/svg"
    width = "600"
    height="800"
    viewBox="0 0 600 800"
      style={{ border: '1px solid red' }}
      data-id="${center}"
      className={className} width="200" height="200" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
      ${renderCenter(center, 'red', 'blue')}
    </svg>`
    return <img src={svgToDataURL(c)}
      alt={center}
      className={className}
    />
  }








  // width = "${width}"
  // height="${height}"
  // viewBox="0 0 ${width} ${height}"


  const renderNumbers = () => {
    let gates = numbers_dictionary;
    Object.keys(gates_dictionary).forEach(oneGate => {
      oneGate = parseInt(oneGate)
      if (highlightedGateInner.includes(oneGate)) {
        const gateRegex = new RegExp(`fill="gate${oneGate}"`, 'g');
        let gateCol = gateColor(oneGate)
        // console.log('gateCol = ', gateCol);
        // console.log('colorThemeInner.openColor = ', colorThemeInner.openColor);
        // gateCol = 'black';
        gateCol = gateCol === colorThemeInner.openColor ? 'black' : gateCol;
        gateCol = gateCol === colorThemeInner.designColor ? colorThemeInner.personalityColor : gateCol;
        gateCol = gateCol === colorThemeInner.personalityColor ? colorThemeInner.openColor : gateCol;
        gates = gates.replace(gateRegex, `fill="${gateCol}"`);
        // console.log('gates = ', gates);
      }
    });
    const gateSelectRegex = /fill="gate\d+"/g;
    gates = gates.replace(gateSelectRegex, 'fill="#838383"');
    return gates;
  };

  const renderSelects = () => {
    let gates = numbers_selects;
    highlightedGateInner.forEach(oneGate => {
      const gateRegex = new RegExp(`fill="gateSelect${oneGate}"`, 'g');
      let gateCol = gateColor(oneGate)
      gates = gates.replace(gateRegex, `fill="${gateCol}"`);
      // const gateStrokeRegex = new RegExp(`stroke="gateSelect${oneGate}"`, 'g');
    });
    // gates = gates.replace(/fill="(?!`${gateCol}`)[^"]+"/g, 'fill="transparent"');
    return gates;
  };



  const svg = `<svg
    xmlns="http://www.w3.org/2000/svg"
    width = "600"
    height="800"
    viewBox="0 0 600 800"

    fill="none"
    preserveAspectRatio="xMidYMid meet"
  >
    ${body && <path d="M184.403 288.337C160.903 294 152.885 305.5 135.903 332.5C118.92 359.5 69.8444 450.734 46.4025 537C33.9025 583 28.6168 624.5 52.9025 658.5C105.281 731.83 184.173 776.547 276.083 776.547C324.051 776.547 295.886 777.567 330.587 776.547C419.772 773.924 504.347 725.762 550.903 648.5C567.523 620.918 565.153 578 555.902 541C532.277 446.5 470.403 340.5 452.426 318.785C441.856 306.016 431.903 293.5 413.903 288.337C389.595 281.365 355.978 276.603 351.386 238.341C347.369 204.875 361.592 198.038 374.349 168.958C387.107 139.879 388.791 110.799 371.798 83.2501C354.805 55.7011 322.298 47.5384 295.252 47.0283C268.206 46.5181 253.073 52.855 236.567 71.0061C221.258 87.8417 216.665 119.472 218.196 124.064C219.727 128.655 222.789 130.186 224.32 136.308C225.596 141.409 214.624 158.755 212.073 164.877C209.521 170.999 212.583 173.04 218.196 176.101C221.882 178.11 222.789 182.223 222.789 190.895C222.789 199.568 221.769 199.058 222.789 211.302C223.81 223.546 232.717 225.579 243.712 222.526C252.897 219.975 255.959 224.566 255.959 233.239C255.959 241.912 252.897 254.156 232.995 270.992C218.629 283.144 204.888 283.401 184.403 288.337Z" fill="#EBEBEB" />}
    ${body_contour}
    ${lines ? lines_svg : ''}
    ${centers.map(one => renderCenter(one, centerColor(one, null, highlighted), strokeColor(one), strokeWidth(one)))}
    ${!composite && numbers ? renderSelects() : ''}
    ${numbers ? renderNumbers() : ''}
    </svg>`
  // ${lines ? lines_svg_selected : ''}

  const svgCenters = `<svg
    xmlns="http://www.w3.org/2000/svg"
    width = "600"
    height="800"
    viewBox="0 0 600 800"

    fill="none"
    preserveAspectRatio="xMidYMid meet"
  >
  ${centers.map(one => renderCenter(one, centerColor(one), strokeColor(one), strokeWidth(one)), centers)}
  ${numbers && numbers_dictionary}
  </svg>`


  // const renderSvg = () => `${context.state.svgs[design['id']]}`


  useEffect(() => {
    if (usePngMode) {
      setSvgWidth(166);
      return;
    }

    const onResize = () => setWH();

    if (parentContainer?.current) {
      setWH();
      window.addEventListener('resize', onResize);
    }

    return () => window.removeEventListener('resize', onResize);
  }, [parentContainer, usePngMode]);

  useEffect(() => {
    setThumbnailFailed(false);
    setThumbnailType('transparent');
  }, [avatarToken, png, design?.id, avatarUpdated]);




  const svgToDataURL = (svg) => {
    const base64Svg = btoa(svg);
    return `data:image/svg+xml;base64,${base64Svg}`;
  };

  // const import bodygraphsvg from './bodygraph.svg';svg = require(`./bodygraph.svg`);


  return (
    <>
      <div className={advanced ? 'x_bodygraph x_bodygraph--magic' : 'x_bodygraph'}
      // onClick={() => handleCloseInfoPop()}
      >

        {planets &&
          <Planets
            label='des'
            design={design}
            advanced={advanced}
            questionPlanets={questionPlanets}
            setHighlightedGate={setHighlightedGateInner}
            highlightedGate={highlightedGateInner}
            fontSize={width < 501 ? '0.8em' : '1em'}
          />
        }


        <div
          className={advanced ? `x_bodygraph_body x_bodygraph_body--magic x_bodygraph_body--${addClassName}` : `x_bodygraph_body x_bodygraph_body--${addClassName}`}
          // ref={bodyContainer}
          // style={{
          //   // width: parentContainer ? svgWidth : width ? width : 100,
          //   // height: parentContainer ? svgHeight : height ? height : 100,
          //   width: svgWidth ? svgWidth : sizes['md'].width,
          //   height: svgHeight ? svgHeight : sizes['md'].height,
          //   opacity: preloader ? 0.4 : 1,
          //   zIndex: 3
          // }}
        >
          <img
            src={bodygraphsvg}
            // src='https://uploads-ssl.webflow.com/643f3bd2d71a69bb42b11dfb/643f3dfa49c20525e8af293b_bodygraph.svg'
            className={`x_bodygraph_svg x_bodygraph_svg--${addClassName}`}
            style={{
              visibility: 'hidden',
              // width: Boolean(svgHeight) ? svgWidth : 'inherit',
              height: Boolean(svgHeight) ? svgHeight : 'inherit',
              // opacity: 0.5
            }}
            ref={bodyContainer}
          />

          {use3d && <Suspense fallback={
            <img
              src={svgToDataURL(svg)}
              alt='bodygraph'
              style={{ position: 'absolute', height: '100%' }}
              className={`x_bodygraph_svg x_bodygraph_svg--${addClassName}`}
            />
          }>
            <Bodygraph3D
              className='x_bodygraph3d--fill'
              design={design}
              penta={penta}
              designComposite={designComposite}
              markers={markers}
              composite={composite}
              default_colors={default_colors}
              centers={centers}
              highlighted={highlightedInner}
              highlightedGate={highlightedGateInner}
              dim={dim}
              authority={authority}
              body={body}
              numbers={numbers}
              whiteLines={whiteLines}
              orbit={orbit3d}
              autoRotate={autoRotate3d}
              appear={appear3d}
              fallback={<img
                src={svgToDataURL(svg)}
                alt='bodygraph'
                style={{ position: 'absolute', height: '100%' }}
                className={`x_bodygraph_svg x_bodygraph_svg--${addClassName}`}
              />}
            />
          </Suspense>}

          {!use3d && (usePngMode
            ? <img
              src={thumbnailUrl}
              alt='bodygraph'
              onError={() => {
                if (thumbnailType === 'transparent') {
                  setThumbnailType('thumbnail');
                } else {
                  setThumbnailFailed(true);
                }
              }}
              style={{
                position: 'absolute',
                height: '100%',
                // width: '100%',
                objectFit: 'contain',
              }}
              className={`x_bodygraph_svg x_bodygraph_svg--${addClassName}`}
            />
            : <img src={svgToDataURL(svg)}
              alt='bodygraph'
              style={{
                position: 'absolute',
                height: '100%',
                // opacity: 0.5
              }}
              className={`x_bodygraph_svg ${hints ? 'x_bodygraph_svg--' : ''}`}
            />)}

          {/* <Svg2
            className={`x_bodygraph_svg ${addClassName}`}
            style={{ position: 'absolute', zIndex: 111 }}
            // width={parentContainer ? svgWidth : width ? width : 100}
            // height={parentContainer ? svgHeight : height ? height : 100}
            width={svgWidth}
            height={svgHeight}
          >
            {svg}
          </Svg2> */}


          {/* {TODO: центры для композита, непонятно} */}
          {/* {composite && <div
            className='x_bodygraph'
            style={{
              zIndex: 3,
              position: 'absolute',
              width: svgWidth ? svgWidth : sizes['md'].width,
              height: svgHeight ? svgHeight : sizes['md'].height,
            }}>
            <Svg
              className='x_bodygraph'
              width={parentContainer ? svgWidth : width ? width : sizes['md'].width}
              height={parentContainer ? svgHeight : height ? height : sizes['md'].height}
            >
              {svgCenters}
            </Svg>
          </div>} */}

          {/* {children} */}

          {preloader && <Preloader0 style={{ paddingTop: '4em' }}><Preloader width={80} height={80} /></Preloader0>}


          {/* <div

          style={{
            width: svgWidth ? svgWidth : sizes['md'].width,
            height: svgHeight ? svgHeight : sizes['md'].height,
            transition: 'opacity 100ms ease-in',
            ...style
          }}
        > */}

          {(!usePngMode || !thumbnailUrl) && design['variables'] && design['variables']['left_down'] && <BodyArrows
            hints={hints}
            theme={{
              designColor: colorThemeInner.designColor,
              personalityColor: colorThemeInner.personalityColor,
            }}
            design={design}
            bodygraphWidth={svgWidth}
            variables={design['variables']}
            arrowsB1={arrowsB}
            arrowsB2={arrowsB}
            arrowsP1={arrowsP}
            arrowsP2={arrowsP}
            // size={svgWidth > 300 ? 'lg' : 'sm'}
            size={'lg'}
          />}





          {
            design.id !== 'dummy' &&
            !use3d &&
            hoverable && <>



            {channels_dictionary.map(one => one.id).map(oneId => {
              const isPickerTrigger = oneId === CHANNEL_PICKER_TRIGGER_ID;
              return (
                <div
                  key={`channel--${oneId}`}
                  className={`x_body_hover_channel x_body_hover_channel--${oneId}`}
                  // style={{ border: '1px solid red' }}
                  onMouseEnter={(e) => {
                    e.stopPropagation();
                    handleChannelHover(oneId);
                  }}
                  onMouseLeave={(e) => {
                    e.stopPropagation();
                    if (channelPickerId !== oneId) handleChannelHover();
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!isPickerTrigger) handleChannelClickInner(oneId);
                  }}
                >
                  {isPickerTrigger ? (
                    <PopoverH
                      trigger="click"
                      placement={isMobile ? 'bottom' : 'left'}
                      popupClassName="x_popover_popup x_body_channel_picker_popup"
                      open={channelPickerId === oneId}
                      onOpenChange={(open) => {
                        setChannelPickerId(open ? oneId : null);
                        if (!open) handleChannelHover();
                      }}
                      title={
                        <ChannelPickerMenu
                          onHover={handleChannelHover}
                          onSelect={(id) => {
                            setChannelPickerId(null);
                            handleChannelClickInner(id);
                          }}
                        />
                      }
                    >
                      <div className="x_body_channel_picker_hit" />
                    </PopoverH>
                  ) : (
                    <TooltipH
                      mouseEnterDelay={500}
                      title={<>{oneId} <span className="x_edu_channel_of _tnowrap">{$ui('channel_of')}</span> <b>{$channel(oneId, 'title')}</b><br />{$channel(oneId, 'description')}</>}
                      className='mobile_v_no'
                    >
                      {/* <div className="x_body_hov x_body_hov--channel" /> */}
                    </TooltipH>
                  )}
                </div>
              );
            })}


            {Object.keys(centersI).map((center, ind) => {

              return <div
                key={`hover_${center.toLowerCase()}`}
                className={`x_body_hover x_body_hover--${center.toLowerCase()}`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleCenterClickInner(center)
                }}
                onMouseOver={() => handleCenterHover(center)}
                onMouseOut={() => handleCenterHover()}
              >


                {hints && <BodyHint center={center} index={ind} design={design} />}

                {/* <TooltipH
                  {...tooltipTheme}
                  mouseEnterDelay={0}
                  title={<><b>{$center(one, 'title')}</b>: {$center(center, 'description')}</>}>
                  <div className="x_body_hov" />
                </TooltipH> */}
                <div className="x_body_hov" />
              </div>
            })}
          </>}


          {
            design.id !== 'dummy' &&
            !use3d &&
            markers &&
            penta &&
            <>



              {markers === 'em' && <BodyMarkers markers={pentaDesign['em']} type='em' penta={penta} />}
              {markers === 'same' && <BodyMarkers markers={pentaDesign['same']} type='same' penta={penta} />}
              {markers === 'dom' && <BodyMarkers markers={pentaDesign['dom']} type='dom' penta={penta} />}




              {Object.keys(centersI).map((center, ind) => {

                return <div
                  key={`hover_${center.toLowerCase()}`}
                  className={`x_body_hover x_body_hover--${center.toLowerCase()}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCenterClickInner(center)
                  }}
                  onMouseOver={() => handleCenterHover(center)}
                  onMouseOut={() => handleCenterHover()}
                >


                  {hints && <BodyHint center={center} index={ind} design={design} />}

                  {/* <TooltipH
                  {...tooltipTheme}
                  mouseEnterDelay={0}
                  title={<><b>{$center(one, 'title')}</b>: {$center(center, 'description')}</>}>
                  <div className="x_body_hov" />
                </TooltipH> */}
                  <div className="x_body_hov" />
                </div>
              })}
            </>}




        </div>

        {planets &&
          <Planets
            label='prs'
            design={design}
            advanced={advanced}
            questionPlanets={questionPlanets}
          highlightedGate={highlightedGateInner}
          setHighlightedGate={setHighlightedGateInner}
          fontSize={width < 501 ? '0.8em' : '1em'}
          />
        }





        {/* <div className='x_bodygraph_svg'
          style={{
            height: svgWidth
          }}
        >
        <Svg
          // width={parentContainer ? svgWidth : width ? width : 100}
          // height={parentContainer ? svgHeight : height ? height : 100}
          width={svgWidth}
          height={svgHeight}
        >
          {svg}
        </Svg>
        </div> */}


        {/* <div
            style={{
              // color: color,
              width: `${width}px`,
              height: `${height}px`,
              // color: color,
              transition: "all 200ms ease-in-out",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "50% 50%",
              backgroundSize: "contain",
              backgroundImage: "url(data:image/svg+xml;base64," + context.state.svgs[design['id']] + ")",
            }} /> */}



        {/* {renderSvg()} */}



        {/* <img src="https://assets.website-files.com/643f3bd2d71a69bb42b11dfb/643f3dfa49c20525e8af293b_bodygraph.svg" loading="lazy" alt /> */}



        {/* </div> */}


      </div>
    </>
  )
})





const BodyMarkers = ({ markers = [], type = 'em', penta }) => {
  const context = { ...useContext(StateContext) };
  const colorMode = context.state.colorMode;

  const memberScheme = (channel) => {
    if (!penta?.members?.length) return null;
    const ownerToken = channel?.activatedBy && Object.keys(channel.activatedBy)[0];
    if (!ownerToken) return null;
    const memberIndex = penta.members.findIndex((one) => one.avatar.token === ownerToken);
    if (memberIndex === 0) return 'composite1';
    if (memberIndex === 1) return 'composite2';
    return null;
  };

  return <>
    {markers.map((channel) => {
      const oneId = channel.id;
      const scheme = type === 'dom' ? memberScheme(channel) : null;
      const markerStyle = scheme
        ? { backgroundColor: colors[colorMode][scheme].prs }
        : undefined;

      return <div
        key={`channel--${oneId}`}
        className={`x_body_hover_channel x_body_hover_channel--${oneId} inact`}
      >
        <div
          className={`x_body_penta_marker x_body_penta_marker--${type}${scheme ? ` x_body_penta_marker--${scheme}` : ''} _o06 inact`}
          style={markerStyle}
        />
      </div>;
    })}
  </>;
}